const postFiltersEl = document.querySelector('.hero-module__filter');
const newsListEl = document.querySelector('.news-list__row');

// Update news list
const updateList = (listEl, listFooterEl, data) => {
  if (listEl && data.list__html) {
    listEl.dataset.page = data.page_number;
    if (parseInt(data.page_number) === 1) {
      listEl.innerHTML = data.list__html;
    } else {
      listEl.innerHTML += data.list__html;
    }
  }

  if (listFooterEl) {
    listFooterEl.classList.toggle('is-hidden', !data.load_more_posts);
  }
};

if (newsListEl) {
  // Axios get filtered post list
  const axiosGetFilteredPostList = async (page, categories, button) => {
    const formDataInput = {
      action: 'getFilteredPostList',
      page,
      categories,
    };

    try {
      const response = await axios.post(localData.siteURL, formDataInput);
      updateList(newsListEl, document.querySelector('.news-list__footer'), response.data.data);
    } catch (err) {
      console.error(err);
    }
    button.disabled = false;
  };

  if (postFiltersEl) {
    // Click event for filter link
    attachEvent('.hero-module__filter-link', 'click', (ev) => {
      postFiltersEl.querySelectorAll('.hero-module__filter-link').forEach((el) => {
        el.classList.remove('is-active');
      });

      ev.target.classList.add('is-active');
      ev.target.disabled = true;

      const categories = ev.target.dataset.category.split(',').map(Number);
      axiosGetFilteredPostList(1, categories, ev.target);
    });
  }

  // Click event for load more button
  attachEvent('.news-list__load-more', 'click', (ev) => {
    ev.preventDefault();
    ev.target.disabled = true;
    const page = parseInt(newsListEl.dataset.page) + 1;
    const categories = postFiltersEl
      ? postFiltersEl.querySelector('.is-active').dataset.category.split(',').map(Number)
      : [];
    axiosGetFilteredPostList(page, categories, ev.target);
  });
}
